import { create } from "zustand";
import { persist } from "zustand/middleware";
import { globalAppAndLanguageDefaultState } from "../utils/constants/GlobalAppAndLanguage";

const useZustandStore = create(
  persist(
    (set, get) => ({
      openSessionExpiredModal: false,
      openLogoutConf: false,
      currentUser: {},
      userPermissions: [],
      firebaseUID: null,
      config: {},
      globalAppAndLanguage: globalAppAndLanguageDefaultState,
      lastLanguageByApp: {},
      appSwitch: null,
      openCommandPalette: false,
      setOpenLogoutConf: (val) => set(() => ({ openLogoutConf: val })),
      setOpenSessionExpiredModal: (val) =>
        set(() => ({ openSessionExpiredModal: val })),
      setCurrentUser: (payload) =>
        set(() => ({
          currentUser: payload || {},
          userPermissions: payload?.permission_codes ?? [],
        })),
      setUserPermissions: (codes) => set(() => ({ userPermissions: codes ?? [] })),
      setFirebaseUID: (payload) => set(() => ({ firebaseUID: payload })),
      setConfig: (payload) => set(() => ({ config: payload || {} })),
      setAppSwitch: (payload) => set(() => ({ appSwitch: payload })),
      setOpenCommandPalette: (val) => set(() => ({ openCommandPalette: val })),
      setGlobalAppAndLanguage: (payload) =>
        set((state) => {
          const next = { ...globalAppAndLanguageDefaultState, ...payload };
          return {
            globalAppAndLanguage: next,
            lastLanguageByApp: {
              ...state.lastLanguageByApp,
              [next.app]: next.language,
            },
          };
        }),
    }),
    {
      name: "seekho-ams-auth",
      partialize: (state) => ({
        currentUser: state.currentUser,
        userPermissions: state.userPermissions,
        globalAppAndLanguage: state.globalAppAndLanguage,
        lastLanguageByApp: state.lastLanguageByApp,
      }),
    }
  )
);

export default useZustandStore;
